import React, { useEffect, useRef, useState } from 'react';
import { DISCOUNTS_VISIBLE } from '../../../config/featureFlags';
import { hapticTick } from '../../../_utils/haptics';
import { useLiveCodes } from '../discountStore';
import { headlineOf } from '../data/codes';
import { codeLine } from './codeMessages';

/**
 * "Add a code" in the text composer: one of the salon's live codes, put in
 * where the cursor is with its conditions and the link that applies it, so a
 * text never promises a code that doesn't exist.
 */
export default function SmsCodeButton({ onInsert, style }) {
  const { codes, loaded } = useLiveCodes();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const off = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const key = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', off);
    document.addEventListener('touchstart', off);
    document.addEventListener('keydown', key);
    return () => {
      document.removeEventListener('mousedown', off);
      document.removeEventListener('touchstart', off);
      document.removeEventListener('keydown', key);
    };
  }, [open]);
  if (!DISCOUNTS_VISIBLE) return null;
  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => { hapticTick(); setOpen((o) => !o); }}
        style={{ padding: '8px 13px', borderRadius: 100, border: '1px dashed #9a9aa2', background: '#fff', fontSize: 12.5, fontWeight: 600, color: '#29282D', cursor: 'pointer', fontFamily: 'inherit', ...style }}
      >
        Add a discount code
      </button>
      {open && (
        <div role="menu" style={{ position: 'absolute', left: 0, top: 'calc(100% + 6px)', zIndex: 50, minWidth: 260, maxWidth: 'min(340px, 86vw)', background: '#fff', border: '1px solid #ECECF0', borderRadius: 12, boxShadow: '0 12px 32px rgba(26,26,30,0.14)', padding: 6 }}>
          {!loaded && <p style={{ margin: 0, padding: '10px 12px', fontSize: 13, color: '#6e6e73' }}>Loading your codes…</p>}
          {loaded && !codes.length && <p style={{ margin: 0, padding: '10px 12px', fontSize: 13, color: '#6e6e73', lineHeight: 1.45 }}>No live codes yet. Make one in Marketing, Discounts.</p>}
          {codes.map((c) => (
            <button
              key={c.id}
              type="button"
              role="menuitem"
              onClick={() => { hapticTick(); setOpen(false); onInsert(codeLine(c)); }}
              style={{ display: 'grid', gap: 2, width: '100%', textAlign: 'left', border: 0, background: 'transparent', borderRadius: 8, padding: '9px 10px', cursor: 'pointer', fontFamily: 'inherit' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#F5F5F7'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <span style={{ fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace', fontWeight: 700, fontSize: 13, letterSpacing: '0.05em', color: '#29282D' }}>{c.code}</span>
              <span style={{ fontSize: 12.5, color: '#6e6e73' }}>{headlineOf(c)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
